module.exports = __webpack_public_path__ + "static/media/GTBSProjectPreview2w1100@2x.56ff61e4.webp";